import { createContext } from 'react';

export type SectionScrollRefCallbacks = [(element?: HTMLElement | HTMLDivElement | HTMLUListElement | undefined | null) => void, (element?: HTMLElement | HTMLUListElement | undefined | null) => void];

export const sectionScrollRefCallbacksContext = createContext<SectionScrollRefCallbacks>([() => { }, () => { }]);
